import { FC, useState } from 'react';
import { default as NextImage } from 'next/legacy/image';
import { Styled, NotificationProps, getIconByNotificationType } from './';
import { useI18n } from 'contexts/i18n';
import { useWindowWidth } from 'utils/hooks';

const Notification: FC<NotificationProps> = ({
  title,
  children,
  type,
  isMultiLine,
  width,
  marginLeft,
  marginTop,
  marginBottom,
  showCloseButton,
  fullWidth,
}) => {
  const [showNotification, setShowNotification] = useState(true);
  const i18n = useI18n();
  console.log();
  const clientWidth = useWindowWidth();
  if (showNotification) {
    return (
      <Styled.NotificationContainer
        type={type}
        width={fullWidth ? `${clientWidth}px` : width}
        marginLeft={marginLeft}
        marginTop={marginTop}
        marginBottom={marginBottom}
        fullWidth={fullWidth}
        clientWidth={clientWidth}
      >
        <Styled.NotificationBody isMultiLine={isMultiLine}>
          <Styled.NotificationTitleContainer>
            <Styled.NotificationIcon>
              {getIconByNotificationType(type)}
            </Styled.NotificationIcon>
            <Styled.NotificationTitle>{title}</Styled.NotificationTitle>
          </Styled.NotificationTitleContainer>

          <Styled.NotificationDescription>
            {children}
          </Styled.NotificationDescription>
        </Styled.NotificationBody>
        {showCloseButton && (
          <Styled.NotificationClose>
            <NextImage
              src={`/images/icons/close.svg`}
              alt="Invisalign"
              height={12}
              width={12}
              onClick={() => setShowNotification(false)}
            />
          </Styled.NotificationClose>
        )}
      </Styled.NotificationContainer>
    );
  } else {
    return <></>;
  }
};

export default Notification;
